import {
  CREATE_BASKET,
  ADD_ITEM_TO_BASKET,
  REMOVE_ITEM_FROM_BASKET,
  BASKET_SYNC_ITEM,
  BASKET_SYNC_FAILED_ITEM,
  BASKET_SYNCED_ITEM,
  CLEAR_BASKET,
} from "./types";

export {
  create_basket_action,
  add_item_action,
  remove_item_action,
  basket_sync_item_action,
  basket_synced_item_action,
  basket_sync_failed_item_action,
  clear_basket_action,
};

// Types
export type ChangeItemPayload = {
  product_id: string | number;
};

export interface SyncItemPayload {
  product_id: string | number;
}

// Impl
function create_basket_action(payload) {
  return {
    type: CREATE_BASKET,
    payload,
  };
}

function add_item_action(payload: ChangeItemPayload) {
  return {
    type: ADD_ITEM_TO_BASKET,
    payload,
  };
}

function remove_item_action(payload: ChangeItemPayload) {
  return {
    type: REMOVE_ITEM_FROM_BASKET,
    payload,
  };
}

function basket_sync_item_action(payload: SyncItemPayload) {
  return {
    type: BASKET_SYNC_ITEM,
    payload,
  };
}

function basket_synced_item_action(payload: SyncItemPayload) {
  return {
    type: BASKET_SYNCED_ITEM,
    payload,
  };
}

function basket_sync_failed_item_action(payload: SyncItemPayload) {
  return {
    type: BASKET_SYNC_FAILED_ITEM,
    payload,
  };
}

function clear_basket_action() {
  return {
    type: CLEAR_BASKET,
  };
}
